<template>
  <div class="locale-changer">
    <button
      href="#"
      class="DropdownList-selectLanguage"
      @click="toggleVisibility"
      @keyDown.space.exact.prevent="toggleVisibility"
      @keyDown.esc.exact="hideDropdown"
      @keyDown.shift.tab="hideDropdown"
      @keyDown.up.exact.prevent="startArrowKeys"
      @keyDown.down.exact.prevent="startArrowKeys"
    >
      <img :src="getLocalLanguageImg()" alt="flag" width="24" />
      <span class="mx-2">{{ $i18n.locale.toUpperCase() }}</span>
      <img
        src="@/assets/arrow-down.png"
        alt="down arrow"
        color="c-soft-black"
        width="10"
      />
    </button>
    <transition name="dropdown-fade">
      <ul
        v-on-clickaway="hideDropdown"
        v-if="isVisible"
        ref="dropdown"
        class="absolute normal-case font-normal xs:left-0 lg:right-0 bg-white
           shadow overflow-hidden rounded w-48 border mt-0 py-1 lg-z:20"
      >
        <li>
          <a
            href="#"
            @click.prevent="setLocale('en')"
            ref="english-flag"
            class="flex items-center px-3 hover:bg-gray-200"
            @keyDown.esc.exact="hideDropdown"
            @keyDown.tab.exact="focusNext(false)"
            @keyDown.up.exact.prevent=""
            @keyDown.down.exact.prevent="focusNext(true)"
          >
            <img src="@/assets/flag-en.png" alt="flag" width="24" />
            <span class="ml-2">English</span>
          </a>
        </li>
        <li>
          <a
            href="#"
            @click.prevent="setLocale('fa')"
            class="flex items-center px-3 hover:bg-gray-200"
            @keyDown.esc.exact="hideDropdown"
            @keyDown.tab.exact="hideDropdown"
            @keyDown.up.exact.prevent="focusPrevious(true)"
            @keyDown.down.exact.prevent=""
            @keyDown.shift.tab="focusPrevious(false)"
          >
            <img src="@/assets/flag-fa.png" alt="flag" width="24" />
            <span class="ml-2">Farsi</span>
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      focusedIndex: 0,
    }
  },
  methods: {
    toggleVisibility() {
      this.isVisible = !this.isVisible
    },
    hideDropdown() {
      this.isVisible = false
      this.focusedIndex = 0
    },
    startArrowKeys() {
      if (this.isVisible) {
        this.$refs.dropdown.children[0].focus()
      }
    },
    focusPrevious(isArrowKey) {
      this.focusedIndex = this.focusedIndex - 1
      if (isArrowKey) {
        this.focusItem()
      }
    },
    focusNext(isArrowKey) {
      this.focusedIndex = this.focusedIndex + 1
      if (isArrowKey) {
        this.focusItem()
      }
    },
    focusItem() {
      this.$refs.dropdown.children[this.focusedIndex].children[0].focus()
    },
    setLocale(locale) {
      this.$i18n.locale = locale

      this.$router.push({
        params: { lang: locale },
      })

      this.hideDropdown()
    },
    getLocalLanguageImg() {
      return require(`@/assets/flag-${this.$i18n.locale}.png`)
    },
  },
}
</script>

<style lang="scss" scoped>
.locale-changer {
  position: relative;
}

.locale-changer ul {
  position: absolute;
  width: 100%;
  list-style-type: none;
  padding-left: 0;
}

.locale-changer ul li {
  margin-bottom: 10px;
  margin-top: 10px;
}

.locale-changer ul li a {
  text-decoration: none;
}

.DropdownList-selectLanguage {
  @include font-category('body');

  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid $c-border-grey;
  border-radius: 4px;
  width: 100%;
  padding: 10px 16px;

  &:disabled {
    color: $c-disabled-grey;
  }
}
</style>
